import { useState, useEffect } from 'react';

const DEFAULT_DATA_LAYERS = {
  geofence: true,
  propertyLines: true,
  restrictedAreas: true,
  serviceAreas: true,
  takeoffAreas: true,
  nearbyAreas: true,
};

export default function useDataLayerVisibility() {
  const [dataLayersVisible, setDataLayersVisible] = useState(() => {
    try {
      const saved = localStorage.getItem('siteTakeoffV2_dataLayers');
      return saved ? { ...DEFAULT_DATA_LAYERS, ...JSON.parse(saved) } : DEFAULT_DATA_LAYERS;
    } catch (_) {
      return DEFAULT_DATA_LAYERS;
    }
  });

  // Listen to localStorage changes from MapLayerControl so toggles stay in sync
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'siteTakeoffV2_dataLayers' && e.newValue) {
        try { setDataLayersVisible({ ...DEFAULT_DATA_LAYERS, ...JSON.parse(e.newValue) }); } catch (_) {}
      }
    };
    window.addEventListener('storage', onStorage);
    // Also poll periodically since same-tab writes don't fire 'storage' event
    const interval = setInterval(() => {
      try {
        const saved = localStorage.getItem('siteTakeoffV2_dataLayers');
        if (saved) {
          const parsed = { ...DEFAULT_DATA_LAYERS, ...JSON.parse(saved) };
          setDataLayersVisible(prev =>
            JSON.stringify(prev) !== JSON.stringify(parsed) ? parsed : prev
          );
        }
      } catch (_) {}
    }, 500);
    return () => {
      window.removeEventListener('storage', onStorage);
      clearInterval(interval);
    };
  }, []);

  return { dataLayersVisible, setDataLayersVisible };
}
